import { connect } from 'react-redux';

import TrolleyMenuHeader from '../components/TrolleyMenuHeader';
import { displayWarning } from 'apps/header/actions/cancelOrderChangesWarning';

export default connect(
  null,
  {
    onCancelOrderChanges: displayWarning,
  },
)(TrolleyMenuHeader);
